import { useState } from 'react'
import Image from 'next/legacy/image'
import { ChevronDown, ChevronUp } from '@components/icons'
import ModalZip from './Modal/ModalZip'
import ModalAfterpay from './Modal/ModalAfterpay'
import ModalHumm from './Modal/ModalHumm'

interface Props {
  price: number
}

const ProductPaymentOptions = ({ price }: Props) => {
  const [seeMore, setSeeMore] = useState(false)
  const [isModalZipOpen, setModalZipIsOpen] = useState(false)
  const [isModalAferpayOpen, setModalAferpayIsOpen] = useState(false)
  const [isModalHummOpen, setModalHummIsOpen] = useState(false)

  if (!price || price === 0) return null

  const priceForFour = (price / 4).toFixed(2)
  const priceForFive = (price / 5).toFixed(2)

  const moreOrLessText = seeMore ? 'See less' : 'See more'

  const readMoreBtnHandler = () => {
    setSeeMore(!seeMore)
  }

  const toggleModalZip = () => {
    setModalZipIsOpen(!isModalZipOpen)
  }

  const toggleModalAfterpay = () => {
    setModalAferpayIsOpen(!isModalAferpayOpen)
  }

  const toggleModalHumm = () => {
    setModalHummIsOpen(!isModalHummOpen)
  }

  return (
    <>
      <div
        className="text-body2 font-normal text-ui-dark-grey flex hover:cursor-pointer pb-1"
        onClick={() => readMoreBtnHandler()}
      >
        {`or installments from $${priceForFour}/week.`} &nbsp;
        <span className="underline px-1">{moreOrLessText}</span>
        <span className="pl-1 pt-2">
          {seeMore ? <ChevronUp /> : <ChevronDown />}
        </span>
      </div>
      {seeMore && (
        <div className="text-10 mobileL:text-body2 font-normal text-ui-dark-grey flex flex-col">
          {isModalZipOpen && <ModalZip onRequestClose={toggleModalZip} />}

          <div
            className="flex items-center cursor-pointer"
            onClick={toggleModalZip}
          >
            <span>{`4 fortnightly payments of $${priceForFour} with `}</span>
            <span className="pl-2">
              <Image
                src="/icons/zip-logo.svg"
                alt="Zip"
                width={39}
                height={20}
                unoptimized
              />
            </span>
            <span className="pl-2 underline">Info</span>
          </div>
          {isModalAferpayOpen && (
            <ModalAfterpay onRequestClose={toggleModalAfterpay} />
          )}
          <div
            className={`flex items-center cursor-pointer`}
            onClick={toggleModalAfterpay}
          >
            <span>{`4 fortnightly payments of $${priceForFour} with `}</span>
            <span className="pl-2 underline">
              <Image
                src="/icons/afterpay-logo.svg"
                alt="Zip"
                width={86}
                height={16}
                unoptimized
              />
            </span>
            <span className="pl-2 underline">Info</span>
          </div>
          {isModalHummOpen && <ModalHumm onRequestClose={toggleModalHumm} />}
          <div
            className="flex items-center cursor-pointer"
            onClick={toggleModalHumm}
          >
            <span>{`5 fortnightly payments of $${priceForFive} with `}</span>
            <span className="pl-2">
              <Image
                src="/icons/humm-logo.svg"
                alt="Zip"
                width={81}
                height={16}
                unoptimized
              />
            </span>
            <span className="pl-2 underline">Info</span>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductPaymentOptions
